export const defaultAudioConstraints = {
  echoCancellation: false,
  noiseSuppression: false,
  autoGainControl: true,
  sampleRate: 48000,
  channelCount: 1
};

const isLocalhost = () => [
  'localhost',
  '127.0.0.1',
  '::1'
].includes(window.location.hostname);

const inIframe = () => {
  try {
    return window.self !== window.top;
  } catch {
    return true;
  }
};

export const getFriendlyMicError = (err) => {
  const name = err && (err.name || err.code) || '';
  const secure = window.isSecureContext || isLocalhost();

  if (!secure) {
    return "Accès micro bloqué: utilisez un contexte sécurisé (HTTPS) ou localhost";
  }

  if (inIframe()) {
    return "Micro bloqué dans l'aperçu intégré. Ouvrez l'aperçu en plein écran puis réessayez";
  }

  switch (name) {
    case 'NotAllowedError':
    case 'PermissionDeniedError':
      return "Permission micro refus��e. Autorisez l'accès au micro dans votre navigateur et réessayez";
    case 'NotFoundError':
    case 'DevicesNotFoundError':
      return "Aucun microphone détecté. Branchez un micro ou sélectionnez-en un dans les réglages système";
    case 'NotReadableError':
    case 'TrackStartError':
      return "Micro indisponible (utilisé par une autre application). Fermez les autres apps utilisant le micro";
    case 'OverconstrainedError':
    case 'ConstraintNotSatisfiedError':
      return "Paramètres audio non supportés par ce micro. Réessayez sans options avancées";
    case 'SecurityError':
      return "Accès micro bloqué par le navigateur. Vérifiez les réglages de confidentialité";
    default:
      return "Impossible d'accéder au micro. Vérifiez les permissions du navigateur";
  }
};

export const requestMicrophone = async (constraints) => {
  const securityOk = window.isSecureContext || isLocalhost();
  if (!securityOk) {
    throw new DOMException('InsecureContext', 'SecurityError');
  }

  if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
    const e = new Error('getUserMedia non supporté');
    e.name = 'NotSupportedError';
    throw e;
  }

  try {
    // Optional: preflight permission query (not supported in all browsers)
    try {
      if (navigator.permissions && navigator.permissions.query) {
        const status = await navigator.permissions.query({ name: 'microphone' });
        if (status.state === 'denied') {
          const e = new DOMException('Permission denied', 'NotAllowedError');
          throw e;
        }
      }
    } catch {}

    const stream = await navigator.mediaDevices.getUserMedia({
      audio: constraints || defaultAudioConstraints
    });
    return stream;
  } catch (err) {
    // Re-throw with same object for upstream mapping
    throw err;
  }
};
